import { B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID, B2B_COPILOT_PLAN_ZIP_ARTIFACT_ID } from './b2bCopilotPlanDemo.js'
import {
  NEXUS_CONNECTED_APP_BLOCKS,
  NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
} from './nexusIntegrationsDemo.js'
import {
  NEXUS_DEMO_CONVERSATION_JOURNEY_TABLE,
  NEXUS_DEMO_DOCUMENTS_TABLE,
  NEXUS_DEMO_GCP_INFRASTRUCTURE_TABLE,
  NEXUS_DEMO_INTEGRATIONS_TABLE,
  NEXUS_DEMO_JOURNEY_INTRO_MARKDOWN,
} from './nexusDemoJourneySummaryContent.part02.js'
import {
  NEXUS_DEMO_EXECUTION_SUMMARY_TABLE,
  NEXUS_DEMO_JOURNEY_WRAP_UP_MARKDOWN,
} from './nexusDemoJourneySummaryContent.part03.js'
import { nexusDoneVerifyLogBlock } from './nexusDemoJourneySummaryContent.part04.js'
import { WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID, WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID } from './websiteCrmDemo.js'
import { ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID } from './zohoCrmIntegrationDemo.js'

export function buildNexusDemoJourneySummaryFinalBlocks(opts = {}) {
  return [
    { type: 'markdown', content: NEXUS_DEMO_JOURNEY_INTRO_MARKDOWN },
    nexusDoneVerifyLogBlock(opts),
    { type: 'heading', level: 3, content: 'Conversation Journey' },
    {
      type: 'markdown',
      content: '*Timeline of your three requests and what was delivered in each step.*',
      variant: 'muted',
    },
    { type: 'table', data: NEXUS_DEMO_CONVERSATION_JOURNEY_TABLE },
    { type: 'heading', level: 3, content: 'Documents Produced' },
    {
      type: 'markdown',
      content: '*Artifacts created during the build — open any file below to review details.*',
      variant: 'muted',
    },
    { type: 'table', data: NEXUS_DEMO_DOCUMENTS_TABLE },
    {
      type: 'fileArtifact',
      fileName: 'B2B Copilot — Development Plan.md',
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: B2B_COPILOT_PLAN_DEMO_ARTIFACT_ID,
    },
    {
      type: 'fileArtifact',
      fileName: 'B2B Copilot.zip',
      description: 'Zip archive',
      artifactKind: 'doc',
      artifactId: B2B_COPILOT_PLAN_ZIP_ARTIFACT_ID,
    },
    {
      type: 'fileArtifact',
      fileName: 'NexusB2B — Procurement Site.html',
      description: 'HTML App',
      artifactKind: 'html',
      artifactId: WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
    },
    {
      type: 'fileArtifact',
      fileName: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID,
    },
    {
      type: 'fileArtifact',
      fileName: 'NexusB2B — CRM Test Report.md',
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID,
    },
    { type: 'heading', level: 3, content: 'Applications Connected' },
    {
      type: 'markdown',
      content: '*Integrations verified and used across the NexusB2B build.*',
      variant: 'muted',
    },
    ...NEXUS_CONNECTED_APP_BLOCKS,
    { type: 'table', data: NEXUS_DEMO_INTEGRATIONS_TABLE },
    { type: 'heading', level: 3, content: 'GCP Production Infrastructure' },
    {
      type: 'markdown',
      content: '*Live production stack after the 9-phase Google Cloud deployment.*',
      variant: 'muted',
    },
    { type: 'table', data: NEXUS_DEMO_GCP_INFRASTRUCTURE_TABLE },
    { type: 'heading', level: 3, content: 'End-to-End Execution Summary' },
    {
      type: 'markdown',
      content: '*Key execution steps and pass/fail results across the full journey.*',
      variant: 'muted',
    },
    { type: 'table', data: NEXUS_DEMO_EXECUTION_SUMMARY_TABLE },
    { type: 'markdown', content: NEXUS_DEMO_JOURNEY_WRAP_UP_MARKDOWN },
  ]
}
